<template>
    <div id="tour-student-eclass-page" class="flex flex-1 space-x-2">

        <DashboardHeaderTab
            :title="'Eclass'"
            :tabs="tabs"
            :activeTab="activeTab"
            :setActiveTab="setActiveTab"
            :toggleSidebar="toggleSidebar"
        />

    </div>
</template>

<script setup lang="ts">
import DashboardHeaderTab from '@/components/DashBoard/common/DashboardHeaderTab.vue';
import SubjectResources from '@/components/StudentDashboard/E-Class/SubjectResources/SubjectResources.vue';
import { useTabs } from '@/composables/useTabs';

const toggleSidebar = inject<() => void>('openMobileNav', () => {});

// Define the tabs
const tabs = ref([
  { name: 'Eclass', component: SubjectResources, query: '' },

]);

// Use the composable for tab management
const { activeTab, setActiveTab } = useTabs(tabs);

</script>

<style>

</style>
